import { render } from "./PublicationSupport.vue.js?vue&type=template&id=323452e8&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSupport.vue?vue&type=template&id=323452e8&scoped=true"
import script from "./PublicationSupport.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSupport.vue?vue&type=script&lang=js"
export * from "./PublicationSupport.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSupport.vue?vue&type=script&lang=js"

import "./PublicationSupport.vue.scss?vue&type=style&index=0&id=323452e8&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSupport.vue?vue&type=style&index=0&id=323452e8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323452e8"],['__file',"src/Web/scripts/pages/publication/PublicationSupport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "323452e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('323452e8', __exports__)) {
    api.reload('323452e8', __exports__)
  }
  
  module.hot.accept("./PublicationSupport.vue.js?vue&type=template&id=323452e8&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSupport.vue?vue&type=template&id=323452e8&scoped=true", () => {
    api.rerender('323452e8', render)
  })

}


export default __exports__